import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// HashRouter doesn't reset scroll position between route changes on its own
// -- without this, navigating to a new page keeps whatever scroll position
// you were at on the previous one.
const ScrollToTop = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return null
}

export default ScrollToTop
